import { render } from "./UserprofilePosts.vue?vue&type=template&id=40ef6644&scoped=true"
import script from "./UserprofilePosts.vue?vue&type=script&lang=js"
export * from "./UserprofilePosts.vue?vue&type=script&lang=js"

import "./UserprofilePosts.vue?vue&type=style&index=0&id=40ef6644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ef6644"]])

export default __exports__